import React from 'react';
import PropTypes from 'prop-types';
import Edit from './rowActions/Edit';
import { Box } from '@mui/material';
import SendCredentialsMesage from './rowActions/SendCredentials';
import Delete from './rowActions/Delete';

const RowActions = ({ rowData, setDetailCallbackComponent }) => <Box>
  <Edit rowData = {rowData} setDetailCallbackComponent = {setDetailCallbackComponent}/>
  <SendCredentialsMesage rowData = {rowData} />
  <Delete rowData = {rowData} />
</Box>;


RowActions.propTypes = {
  row: PropTypes.object.isRequired,
  setDetailCallbackComponent: PropTypes.func
};


export default RowActions;
